import React from 'react';
import { Link } from 'react-router-dom';
import {
  MEMBER_FEATURE_GATE_COPY,
  type MemberFeatureGateId,
} from '../../constants/membershipAccess';
import { MEMBERSHIP_APPLY_PATH, SCHEDULE_DEMO_PATH } from '../../constants/dataUsePolicy';
import { MembershipOptionsTiers } from './MembershipOptionsTiers';
import './MemberFeatureGatePage.css';

export interface MemberFeatureGatePageProps {
  feature: MemberFeatureGateId;
}

export const MemberFeatureGatePage: React.FC<MemberFeatureGatePageProps> = ({ feature }) => {
  const copy = MEMBER_FEATURE_GATE_COPY[feature];

  return (
    <div className="member-feature-gate">
      <header className="member-feature-gate__header">
        <h1>{copy.title}</h1>
        <p className="member-feature-gate__message">{copy.message}</p>
        <p className="member-feature-gate__subtext">{copy.subtext}</p>
        <div className="member-feature-gate__actions">
          <Link to={MEMBERSHIP_APPLY_PATH} className="member-feature-gate__btn member-feature-gate__btn--primary">
            Become a Member
          </Link>
          <Link to={SCHEDULE_DEMO_PATH} className="member-feature-gate__btn member-feature-gate__btn--primary">
            Schedule a Demo
          </Link>
        </div>
      </header>

      <MembershipOptionsTiers />
    </div>
  );
};

export default MemberFeatureGatePage;
